import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmationService, } from 'primeng/api';
import { ActivatedRoute, ParamMap } from '@angular/router'
import { CoreService } from '../core/_services/core.services';
import { AlertasService } from '../core/_services/alerta.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppBreadcrumbService } from '../consola/app.breadcrumb.service';
import { ValidatorUtils } from '../core/_util/validator-util';


@Component({
  selector: 'app-disponibilidad',
  templateUrl: './disponibilidad.component.html',
  styleUrls: ['./disponibilidad.component.scss']
})
export class DisponibilidadComponent extends ValidatorUtils implements OnInit {

  @Input() fichaActual: any;

  //formulario
  formBuilder: FormBuilder;
  formulario: FormGroup;
  mostrarFormulario: Boolean = false;
  registroNuevo: Boolean = false;
  submitted: Boolean = false;

  //lista de registros
  registrosLista: any;
  columnas: any[];
  totalRecords = 0;
  listaDias: any[];
  listadoHorarios: any[];
  cargandoPagina: boolean = false;
  datos: any;

  espanol: any;
  tipoDia: any;
  horaInicial: any;
  horaFinal: any;

  diasAdicionales: any[];

  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    public confirmationService: ConfirmationService
  ) {
    super();
    this.formBuilder = new FormBuilder();
    this.formulario = this.formBuilder.group({
      tipoDia: ['', Validators.required],
      horaInicial: ['', Validators.required],
      horaFinal: ['', Validators.required],

    });

  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'dia_id', subfield: 'cod_tip_referencia', header: 'Dia de Atención' },
      { field: 'hora_inicio', header: 'Apertura' },
      { field: 'hora_fin', header: 'Cierre' },
    ];

    this.totalRecords = 0;
    this.listar();
    this.getlistatipodia();
    this.cargarDatos();
  }


  nuevo() {
    this.formulario.reset();
    this.mostrarFormulario = true;
    this.registroNuevo = true;
  }

  editar(data) {
    this.registroNuevo = false;
    this.mostrarFormulario = true;
  }

  volver() {
    this.mostrarFormulario = false;
    this.submitted = false;
  }

  guardar() {
    var dat = this.formulario.valid;

    this.formulario.markAllAsTouched();
    if (dat) {
      this.confirmationService.confirm({
        message: '¿Desea guardar este registro?',
        accept: () => {
          this.submitted = true;
          this.guardarHorario();

        }
      });
    }
  }

  listar() {
    let data = {
      id_ficha: this.fichaActual

    }
    this.mostrarFormulario = false;
    this.coreService.getWithParams('/obtenerHorarioFicha', data).subscribe(
      (res: any[]) => {
        // console.log(res);
        this.listadoHorarios = res;
        this.totalRecords = this.listadoHorarios.length;

      },
      (err: any) => {
        console.log(err);
      }
    )

  }
  getlistatipodia() {
    this.coreService.get('/obtenerlistaDia').subscribe(
      (res: any) => {

        this.listaDias = res.servicio;
      },
      (err: any) => {
        console.log(err);
      }
    )

  }

  cargarDatos() {
    this.cargandoPagina = true;
    this.coreService.get('/datos-inicio').subscribe(
      (res: any) => {
        this.datos = res.datos;
      });
  }


  guardarHorario() {
    let data = {
      fichaActual: this.fichaActual,
      dias_id: this.formulario.value.tipoDia.id,
      usuario: this.datos.user_id,
      hora_inicio: new Date(this.formulario.value.horaInicial).getHours() + ':' + (new Date(this.formulario.value.horaInicial).getMinutes() == 0 ? '00' : new Date(this.formulario.value.horaInicial).getMinutes()),
      hora_fin: new Date(this.formulario.value.horaFinal).getHours() + ':' + (new Date(this.formulario.value.horaFinal).getMinutes() == 0 ? '00' : new Date(this.formulario.value.horaFinal).getMinutes()),
    }

    if (this.formulario.value.horaInicial > this.formulario.value.horaFinal) {

      this.msj.alerta('La Hora Inicial es mayor que la Final');
    } else {

      this.coreService.post('/guardar-horario', data).subscribe(
        (res: any[]) => {
          this.msj.info('Registro Guardado.');
          this.listar();
          this.mostrarFormulario = false;
        },
        (err: any) => {
          console.log(err);
        }
      )
    }
  }



  eliminar(idRegistro) {
    this.confirmationService.confirm({
      message: '¿Desea eliminar el registro con ID:' + idRegistro.id + '?',
      accept: () => {
        this.submitted = true;
        this.eliminarHorario(idRegistro.id);
        this.mostrarFormulario = false;

      }
    });
  }

  eliminarHorario(idRegistro) {
    this.coreService.delete('/eliminar-horario', idRegistro).subscribe(
      (res: any[]) => {
        this.msj.info('Registro Eliminado.');
        this.listar();
      },
      (err: any) => {
        if (err.error !== undefined && err.error !== null) {
          for (let index = 0; index < err.error.length; index++) {
            this.msj.error(err.error[index]);
          }
        }
      }
    );
  }

}
